
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useForm } from "react-hook-form";
import { useLocationVersions } from "../hooks/useLocationVersions";
import { CampLocation } from "@/types/campLocation";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import { useState } from "react";
import { AgeGroupVariationModal } from "../LocationFormSections/AgeGroupVariationModal";
import { AgeGroupsOfferingsSection } from "../LocationFormSections/AgeGroupsOfferingsSection";
import { UserInvitation } from "@/types/userInvitation";
import { Organization } from "@/types/organization";
import type { AgeGroupVariationFormData } from "../LocationFormSections/schemas/ageGroupVariationSchema";

interface OfferingsAndSessionsTabProps {
  location: CampLocation;
  versionId?: string | null;
  isWelcomeScreen?: boolean;
  invitation?: UserInvitation;
  onProgramSaved?: (locationId: string) => Promise<void>;
  organizationData?: Organization | null;
  /** Proposal pre-fill from the Automation Admin tab's [Review] action; opens the editor pre-filled. */
  prefillVariation?: Partial<AgeGroupVariationFormData> | null;
  onPrefillConsumed?: () => void;
}

export const OfferingsAndSessionsTab: React.FC<OfferingsAndSessionsTabProps> = ({
  location,
  versionId,
  isWelcomeScreen = false,
  invitation,
  onProgramSaved,
  organizationData,
  prefillVariation = null,
  onPrefillConsumed
}) => {
  const { latestVersion } = useLocationVersions(location.id);
  const showCopyFromLocationButton = Boolean(isWelcomeScreen && organizationData && (organizationData as any).numPublishedLocations > 1);
  
  return (
    <div className="space-y-6 p-1">
      <AgeGroupsOfferingsSection
        location={location}
        isWelcomeScreen={isWelcomeScreen}
        invitation={invitation}
        onProgramSaved={onProgramSaved}
        showCopyFromLocationButton={showCopyFromLocationButton}
        prefillVariation={prefillVariation}
        onPrefillConsumed={onPrefillConsumed}
      />
    </div>
  );
};
